import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { useUserStore } from '@Auth/store';
import { useEntityStore } from '@ContractBuilder/store';
import { isEndorsementData } from '@ContractBuilder/types';
import Nav from '@src/routes';

import { useRecentStorage } from './useRecentStorage';

/** Records the currently open contract in the palette's "recently viewed" list. */
export function useTrackRecentContract() {
  const location = useLocation();
  const submission = useEntityStore(({ submission }) => submission);
  const user = useUserStore(({ user }) => user);
  const { addRecentContract } = useRecentStorage(user?.username ?? '');
  const isContractRoute = !!matchPath({ path: Nav.Submission }, location.pathname);
  const isEndorsementRoute = location.pathname.includes('/endorsements/');

  useEffect(() => {
    if (!isContractRoute || isEndorsementRoute || !submission || isEndorsementData(submission)) {
      return;
    }

    addRecentContract({
      id: submission.id,
      name: submission.name ?? '',
      ref: submission.ref,
      status: submission.status,
    });
  }, [isContractRoute, isEndorsementRoute, submission?.id]); // eslint-disable-line react-hooks/exhaustive-deps -- record once per contract visit
}
